var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chevron-down-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_5",
    transform: "translate(-350.000000, -1273.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy-3",
    transform: "translate(20.000000, 1253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-outline",
    transform: "translate(330.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5261749,15.2727273 C12.2664433,15.2743843 12.0168007,15.160626 11.8323926,14.9565631 L7.92376003,10.5959292 C7.67589549,10.3194012 7.57909336,9.91635275 7.66981807,9.53860842 C7.76054279,9.16086409 8.0250111,8.86581218 8.36360036,8.76459589 C8.70218962,8.66337961 9.06346006,8.77137611 9.31132459,9.04790416 L12.5261749,12.6563287 L15.7507967,9.18962476 C15.99583,8.88565271 16.372707,8.76017627 16.7269873,8.86461453 C17.0812675,8.96905278 17.3533948,9.28584917 17.4318539,9.6851835 C17.5103129,10.0845178 17.3819145,10.4992602 17.099275,10.759453 L13.1906424,14.9674647 C13.0119445,15.159676 12.774376,15.2688107 12.5261749,15.2727273 L12.5261749,15.2727273 Z",
    id: "Path",
    fill: "#1D2B7D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.c3a9084e03ee5d5622f2848b60ff4ddd.svg";
export { ForwardRef as ReactComponent };